import { useQuery } from "@tanstack/react-query";
import "./styles/homecategory.css";
import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import { MdArrowBackIosNew, MdArrowForwardIos } from "react-icons/md";
import './homecategory.css'

const HomeCategory = () => {
  const baseUrl = process.env.REACT_APP_API_URL;

  const fetchCategories = async () => {
    const token = localStorage.getItem("token");
    const res = await fetch(`${baseUrl}catagorylist`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) throw new Error("Failed to fetch categories");
    return res.json();
  };

  const { data: categories = [] } = useQuery({
    queryKey: ["categories-list"],
    queryFn: fetchCategories,
  });

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <div className="category-home-bg">
      <div className="container category-container position-relative">
        {/* Custom Navigation Buttons */}
        <button ref={prevRef} className="custom-nav-button left">
        <MdArrowBackIosNew />
        </button>
        <button ref={nextRef} className="custom-nav-button right">
        <MdArrowForwardIos />
        </button>

        <Swiper
  grabCursor={true}
  spaceBetween={30}
  centeredSlides={false}
  onInit={(swiper) => {
    swiper.params.navigation.prevEl = prevRef.current;
    swiper.params.navigation.nextEl = nextRef.current;
    swiper.navigation.init();
    swiper.navigation.update();
  }}
  breakpoints={{
    0: {
      slidesPerView: 3,
      spaceBetween:2,
    },
    768: {
      slidesPerView: 5,
    },
    1024: {
      slidesPerView: 6,
    },
  }}
  modules={[Navigation]}
  className="swiper-categorys"
>

          {categories?.catagories?.map((category) => (
            <SwiperSlide key={category._id} className="silde-category-parent">
              <Link
                state={{ isScroll: true }}
                to={`/category/${category._id}`}
                className="slide-category"
              >
                <img
                  className="category-image"
                  style={{
                    width:"60px",
                    height:"60px"
                  }}
                  src="https://cdn-icons-png.flaticon.com/128/763/763072.png"
                  alt=""
                />
                <p className="category-text-name">{category.catagoryname}</p>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default HomeCategory;
